module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Light.30866b9.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Light.otf
// module id = FV+v
// module chunks = 0